import request from '@/utils/request'

export function loginByUsername2(data) {
    return request({
        url: '/LabManage-server/admin/loginApi/loginSubmit',
        baseURL: url,
        method: 'post',
        params: data
    })
}
//  登陆
export function userLogin(data) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        params: data
    })
}
//  邮箱登陆
export function remote(data) {
    return request({
        url: '/api/auth/remote',
        method: 'post',
        params: data
    })
}
//  老用户登录绑定手机
export function authbind(data) {
    return request({
        url: '/api/auth/bind',
        method: 'post',
        params: data
    })
}
//忘记密码
export function forget_pwd(data) {
    return request({
        url: '/api/user/forget_pwd',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js